/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Sign_In_To_BookInputs */

const en_directory_ads_sign_in_to_book = /** @type {(inputs: Directory_Ads_Sign_In_To_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to book`)
};

const zh_directory_ads_sign_in_to_book = /** @type {(inputs: Directory_Ads_Sign_In_To_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后预订`)
};

/**
* | output |
* | --- |
* | "Sign in to book" |
*
* @param {Directory_Ads_Sign_In_To_BookInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_sign_in_to_book = /** @type {((inputs?: Directory_Ads_Sign_In_To_BookInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Sign_In_To_BookInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_sign_in_to_book(inputs)
	return zh_directory_ads_sign_in_to_book(inputs)
});
export { directory_ads_sign_in_to_book as "directory.ads.sign_in_to_book" }